import type { ReactNode, FC, ComponentProps } from 'react';
import type { IconName } from '../Icon';
import { themeColors } from '../../utils';
import { cx } from '@emotion/css';
import Icon from '../Icon';
import ODSButton from '../ODSButton';
import type { ODSModalContainerProps } from './ODSModalContainer';

export interface ODSModalHeaderProps extends Omit<ComponentProps<'div'>, 'title'> {
  /** Does this modal perform a delete or permanent action @deprecated */
  danger?: boolean;
  /** Disables the close button if the modal is loading or submitting */
  disabled?: boolean;
  /** Adds a red icon to the title  */
  error?: boolean;
  /** Hide close btn at the top right */
  hideClose?: boolean;
  /** Display an icon in the primary button  */
  icon?: IconName;
  /** Apply a light background for the heading */
  light?: boolean;
  /** Add a sub title below the title */
  subTitle?: ReactNode;
  /** Heading title for the modal */
  title?: ReactNode;
  /** Add a yellow icon to the title */
  warning?: boolean;
  /** Toggle function to close the modal */
  toggle?: ODSModalContainerProps['toggle']; // TODO: remove this and update all tests
  /** @deprecated Use hideClose instead. Close button should be present by default (03/31/26) */
  close?: never;
}

export const ODSModalHeader: FC<ODSModalHeaderProps> = ({
  children,
  className,
  danger: _danger, // TODO: Unused
  disabled,
  error,
  hideClose,
  icon,
  light,
  subTitle,
  title,
  warning,
  toggle,
  ...componentProps
}) => {
  let titleIcon: IconName | undefined = icon;
  let titleIconColor: string | undefined;

  if (error) {
    titleIcon = 'hexagon-exclamation';
    titleIconColor = themeColors.danger;
  } else if (warning) {
    titleIcon = 'triangle-exclamation';
    titleIconColor = themeColors.warning;
  }

  return (
    <div
      className={cx(
        className,
        'ods-modal-header d-flex border-bottom justify-content-between align-items-start gap-2',
        {
          'bg-light': light,
        }
      )}
      css={{ borderTopLeftRadius: 'inherit', borderTopRightRadius: 'inherit' }}
      {...componentProps}
    >
      <div className="px-3 pt-3 pb-2 w-100">
        {/* TODO: This should be a Dialog.Title */}
        {!!title && (
          <h2 className="modal-title mb-1 fs-5" data-testid="modal-title">
            {titleIcon && <Icon name={titleIcon} color={titleIconColor} className="me-2" />}
            {title}
          </h2>
        )}
        {!!subTitle && <div className="text-secondary normal fw-normal">{subTitle}</div>}
        {children}
      </div>

      {!hideClose && toggle && (
        <div className="p-2">
          {/* TODO: This should be a Dialog.Close */}
          <ODSButton
            icon="times"
            size="md"
            quiet
            disabled={disabled}
            data-testid="modal-close-button"
            onClick={(e) => {
              toggle(e.nativeEvent);
            }}
          />
        </div>
      )}
    </div>
  );
};
